module.exports = __webpack_public_path__ + "img/42_15.afad71b7.png";